/**
 * Created by intellicar-rinas on 8/1/18.
 */
import React, {Component} from 'react';
import './PaverView.css';
import Dom from '../../../../helpers/Dom';
import ignitionIcon from '../../../../assets/svg/paver/ignition.svg';
import eStopIcon from '../../../../assets/svg/paver/estop.svg';
import coolantIcon from '../../../../assets/svg/paver/coolant.svg';
import lubeOilIcon from '../../../../assets/svg/paver/lubeoil.svg';
import airFilterIcon from '../../../../assets/svg/paver/airfilter.svg';
import oilFilterIcon from '../../../../assets/svg/paver/oilfilter.svg';
import ignitionActiveIcon from '../../../../assets/svg/paver/ignitionActive.svg';
import eStopActiveIcon from '../../../../assets/svg/paver/estopActive.svg';
import coolantActiveIcon from '../../../../assets/svg/paver/coolantActive.svg';
import lubeOilActiveIcon from '../../../../assets/svg/paver/lubeoilActive.svg';
import airFilterActiveIcon from '../../../../assets/svg/paver/airfilterActive.svg';
import oilFilterActiveIcon from '../../../../assets/svg/paver/oilfilterActive.svg';
import logo from '../../../../assets/svg/paver/logo.png';
import lscreed from '../../../../assets/svg/paver/lscreed.png';
import rscreed from '../../../../assets/svg/paver/rscreed.png';
import bscreed from '../../../../assets/svg/paver/bscreed.png';
import batteryIcon from '../../../../assets/svg/paver/battery.png';
import {dateFormat} from '../../../../constants/constants';
import moment from 'moment';
import InPieChart from '../../../ReportWindow/schema/InPieChart/InPieChart';
import ReportAPIs from '../../../../APIs/ReportAPIs';

class PaverView extends  Component {

    state = {
        vehicle:{
            stats:{},
            vehiclemeta:{}
        }
    }

    constructor() {
        super();

        this.updateView =()=> {
            if(this.props && this.props.vehicle) {
                this.setState({vehicle: this.props.vehicle()}, ()=>{
                    this.forceUpdate();
                    this.getData();
                });
            } else {
                this.forceUpdate();
                this.getData();
            }
        };

        this.isSimulating =()=> {
            return window.getMQTTSimulationStatus ? window.getMQTTSimulationStatus() : false;
        };

        this.toggleSimulation =()=> {
            if(window.getMQTTSimulationStatus) {
                let status = window.getMQTTSimulationStatus();
                if(status) {
                    window.stopMQTTSimulation()
                } else {
                    window.startMQTTSimulation()
                }
                setTimeout(()=>this.forceUpdate(), 200);
            }
        };

        this.clearState =(callback)=> {
            this.setState({stats:{}, can2:{}, vehicle:{}}, callback);
        };

        this.getTime =()=> {
            return this.state.vehicle && this.state.vehicle.stats && moment(this.state.vehicle.stats.time).format(dateFormat);
        }

        this.get =key=> {
            if(this.state.vehicle && key in this.state.vehicle){
                return this.state.vehicle[key];
            }
            if(this.state.vehicle.CAN && key in this.state.vehicle.CAN){
                return this.state.vehicle.CAN[key];
            } 
            if(this.state.vehicle.stats && key in this.state.vehicle.stats){
                return this.state.vehicle.stats[key];
            }
            if(this.state.vehicle.vehiclemeta && key in this.state.vehicle.vehiclemeta ) {
               return  this.state.vehicle.vehiclemeta[key];
            }      

        };

        this.isSimulating =()=> {
            return window.getMQTTSimulationStatus ? window.getMQTTSimulationStatus() : false;
        };

        this.toggleSimulation =()=> {
            if(window.getMQTTSimulationStatus) {
                let status = window.getMQTTSimulationStatus();
                if(status) {
                    window.stopMQTTSimulation()
                } else {
                    window.startMQTTSimulation()
                }
                setTimeout(()=>this.forceUpdate(), 200);
            }
        }

        this.getPieConfig =index=> {
            return {}
        };

        this.getData = () => {

            if(!this.refs.graph1 || !this.refs.graph2 || !this.refs.graph3) {
                setTimeout(this.getData, 100);
                return;
            }


            if(!this.props.vehicle)
                return;

            let today = moment(Date.now()).startOf('day');

            let body = {
                vehicleid:this.props.vehicle().vehicleid,
                starttime:today.unix() * 1000,
                endtime:today.add(24, 'hours').unix() * 1000
            };

            const handleFailure =resp=> { console.log("PaverScreen: Fetching data failed") };

            ReportAPIs.getPaverPopupMetrics(body)
                .then(resp=>{

                    if(!this.refs.graph1 || !this.refs.graph2 || !this.refs.graph3 || !this.refs.graph4) return;

                    this.refs.graph1.setData({
                        data:[
                            {name:'High Gear', color:'#1d5577', value:resp.highgeartraveldistance},
                            {name:'Low Gear', color:'#4fb5a0', value:resp.lowgeartraveldistance}
                        ],
                        unit:'Km',
                        name:'Distance',
                    });
                    this.refs.graph2.setData({
                        data:[
                            {name:'High Gear', color:'#1d5577', value:resp.highgeartraveltime},
                            {name:'Low Gear', color:'#4fb5a0', value:resp.lowgeartraveltime},
                            {name:'Idle', color:'#b53556', value:resp.idletraveltime}
                        ],
                        unit:'m',
                        name:'Travel Time',
                    });
                    this.refs.graph3.setData({
                        data:[
                            {name:'w/ Heating', color:'#1d5577', value:resp.pavingwithheatingtime},
                            {name:'w/o Heating', color:'#4fb5a0', value:resp.pavingwithoutheatingtime}
                        ],
                        unit:'m',
                        name:'Paving',
                    });
                    this.refs.graph4.setData({
                        data:[
                            {name:'With Heating', color:'#1d5577', value:resp.pavingwithheatingtime},
                            {name:'Without Heating', color:'#4fb5a0', value:resp.pavingwithoutheatingtime},
                            {name:'High Gear', color:'#34772f', value:resp.highgeartraveltime},
                            {name:'Low Gear', color:'#b59944', value:resp.lowgeartraveltime},
                            {name:'Idle', color:'#b53556', value:resp.idletraveltime}
                        ],
                        unit:'m',
                        name:'Overall',
                    });
                }, handleFailure)


        }
    }

    render() {
        return (
            <div className="PaverView -paver">
                <div className={"pv-sim-button "+(this.isSimulating() ? 'active': '')} onClick={()=>this.toggleSimulation()}>SIM</div>
                <div className="pv-header">
                    <div className="pvh-desc1">VOLVO PAVER</div>
                    <div className="pvh-desc2">{this.get('modelnumbermsb')}</div>
                    <div className="pvh-desc3">{this.state.vehicle.vehicleno}</div>
                    <img src={logo}/>
                    <div className="pvh-time">
                        <span className="pvht-icon"></span>
                        <span className="pvht-1">Last seen on</span>
                        <span className="pvht-2">{this.getTime()}</span>
                    </div>
                </div>
                <div className="pv-digitalBlock">
                    <div className="pvdb-top">
                        <div className="pvdbt-bar">
                            <div className="pvdbtb-value">{this.get('aes')}</div>
                            <div className="pvdbtb-name">RPM x100</div>
                            <div className="pvdbtb-tick pvdbtb-tick-1">0</div>
                            <div className="pvdbtb-tick pvdbtb-tick-2">6</div>
                            <div className="pvdbtb-tick pvdbtb-tick-3">12</div>
                            <div className="pvdbtb-tick pvdbtb-tick-4">18</div>
                            <div className="pvdbtb-tick pvdbtb-tick-5">26</div>
                            <div className="pvdbtb-tick pvdbtb-tick-6">30</div>
                            <div className="pvdbtb-progress">
                                <div className="pvdbtbp-overlay"></div>
                                <div className="pvdbtbp-fill" style={{width:(this.get('aes') * 100 / 3000)+ '%'}}><div className="pvdbtbpf-shade"></div></div>
                            </div>
                        </div>
                        <div className="pvdbt-bar">
                            <div className="pvdbtb-value">{this.get('ds')}<span>mpm</span></div>
                            <div className="pvdbtb-name">SPEED</div>
                            <div className="pvdbtb-tick pvdbtb-tick-1">0</div>
                            <div className="pvdbtb-tick pvdbtb-tick-2">20</div>
                            <div className="pvdbtb-tick pvdbtb-tick-3">40</div>
                            <div className="pvdbtb-tick pvdbtb-tick-4">60</div>
                            <div className="pvdbtb-tick pvdbtb-tick-5">80</div>
                            <div className="pvdbtb-tick pvdbtb-tick-6">100</div>
                            <div className="pvdbtb-progress">
                                <div className="pvdbtbp-overlay"></div>
                                <div className="pvdbtbp-fill" style={{width:this.get('ds') + '%'}}><div className="pvdbtbpf-shade"></div></div>
                            </div>
                        </div>
                    </div>
                    <div className="pvdb-bottom">
                        <div className={"pvdbb-item "+(this.get('iig') ? 'active' : '')}>
                            <div className="pvdbbi-body">
                                {this.get('iig') ? <object data={ignitionActiveIcon}></object> : <object data={ignitionIcon}></object>}
                            </div>
                            <div className="pvdbbi-name">IGNITION</div>
                        </div>
                        <div className={"pvdbb-item "+(this.get('ioe') ? 'active' : '')}>
                            <div className="pvdbbi-body">
                                {this.get('ioe') ? <object data={eStopActiveIcon}></object> : <object data={eStopIcon}></object>}
                            </div>
                            <div className="pvdbbi-name">E-STOP</div>
                        </div>
                        <div className={"pvdbb-item "+(this.get('hct') ? 'active' : '')}>
                            <div className="pvdbbi-body">
                                {this.get('hct') ? <object data={coolantActiveIcon}></object> : <object data={coolantIcon}></object>}
                            </div>
                            <div className="pvdbbi-name">HIGH COOLANT</div>
                        </div>
                        <div className={"pvdbb-item "+(this.get('eol') ? 'active' : '')}>
                            <div className="pvdbbi-body">
                                {this.get('eol') ? <object data={lubeOilActiveIcon}></object> : <object data={lubeOilIcon}></object>}
                            </div>
                            <div className="pvdbbi-name">LUBE OIL PRESSURE</div>
                        </div>
                        <div className={"pvdbb-item "+(this.get('ioa') ? 'active' : '')}>
                            <div className="pvdbbi-body">
                                {this.get('ioa') ? <object data={airFilterActiveIcon}></object> : <object data={airFilterIcon}></object>}
                            </div>
                            <div className="pvdbbi-name">AIR FILTER CLOGGED</div>
                        </div>
                        <div className={"pvdbb-item "+(this.get('hfi') ? 'active' : '')}>
                            <div className="pvdbbi-body">
                                {this.get('hfi') ? <object data={oilFilterActiveIcon}></object> : <object data={oilFilterIcon}></object>}
                            </div>
                            <div className="pvdbbi-name">OIL FILTER CLOGGED</div>
                        </div>
                    </div>
                </div>
                <div className="pv-block pv-heatBlock">
                    <div className="pv-body">
                        <div className="pvhb-top">
                            <div className="pvhbt-desc1">SCREED TEMPERATURE</div>
                            <div className="pvhbt-desc2">SCREED HEATING MODE</div>
                            <div className="pvhbt-desc3">{this.get('shm') ? 'PAVING' : 'NEUTRAL'}</div>
                        </div>
                        <div className="pvhb-bottom">
                            <div className="pvhbb-item">
                                <div className="pvhbbi-desc1">{this.get('lst')}℃</div>
                                <div className="pvhbbi-desc2">LEFT SCREED</div>
                                <div className={"pvhbbi-desc3 "+(this.get('shsl') !== 2 ? 'active':'')}><i className="fa fa-exclamation-triangle"></i> SENSOR FAILURE</div>
                                <div className="pvhbbi-icon"><img src={lscreed}/></div>
                            </div>
                            <div className="pvhbb-item">
                                <div className="pvhbbi-desc1">{this.get('bct')}℃</div>
                                <div className="pvhbbi-desc2">BASE SCREED</div>
                                <div className={"pvhbbi-desc3 "+(this.get('shsb') !== 2 ? 'active':'')}><i className="fa fa-exclamation-triangle"></i> SENSOR FAILURE</div>
                                <div className="pvhbbi-icon"><img src={bscreed}/></div>
                            </div>
                            <div className="pvhbb-item">
                                <div className="pvhbbi-desc1">{this.get('rst')}℃</div>
                                <div className="pvhbbi-desc2">RIGHT SCREED</div>
                                <div className={"pvhbbi-desc3 "+(this.get('shsr') !== 2 ? 'active':'')}><i className="fa fa-exclamation-triangle"></i> SENSOR FAILURE</div>
                                <div className="pvhbbi-icon"><img src={rscreed}/></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pv-block pv-chartBlock">
                    <div className="pv-body">
                        <div className="pvcb-item"><InPieChart ref="graph1" config={this.getPieConfig(0)}/></div>
                        <div className="pvcb-item"><InPieChart ref="graph2" config={this.getPieConfig(1)}/></div>
                        <div className="pvcb-item"><InPieChart ref="graph3" config={this.getPieConfig(2)}/></div>
                    </div>
                </div>
                <div className="pv-block pv-squareBlock">
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">BATTERY</div>
                            <div className="pvsb-desc2">{parseFloat(this.get('iov')/10).toFixed(1)}<span>v</span></div>
                            {
                                this.get('bci') ? (
                                    <div className="pvsb-desc3">
                                        <img src={batteryIcon}/>
                                        <span>CHARGING</span>
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">DAILY MACHINE HMR</div>
                            <div className="pvsb-desc2">{parseFloat(this.get('eh')).toFixed(1)}<span>hrs</span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">DAILY PAVING HRS</div>
                            <div className="pvsb-desc2">{parseFloat(this.get('wh') + (this.get('wm') / 60).toFixed(1))}<span>hrs</span></div>
                        </div>
                    </div>
                    <div className="pvb4-item">
                        <div className="pv-body">
                            <div className="pvsb-desc1">DAILY PAVING DISTANCE</div>
                            <div className="pvsb-desc2">{parseFloat((this.get('pd') / 1000).toFixed(1)).toFixed(1)}<span>km</span></div>
                        </div>
                    </div>
                </div>
                <div className="pv-block pv-triBlock">
                    <div className="pv-body">
                        <div className="pvtb-name">LOW GEAR</div>
                        <div className="pvtb-item">
                            <div className="pvtbi-desc1">MACHINE MOVING</div>
                            <div className="pvtbi-desc2">{this.get('wlm')}<span>hrs</span></div>
                        </div>
                        <div className="pvtb-item">
                            <div className="pvtbi-desc1">MACHINE IDLE</div>
                            <div className="pvtbi-desc2">{this.get('wli')}<span>hrs</span></div>
                        </div>
                        <div className="pvtb-item">
                            <div className="pvtbi-desc1">MACHINE DISTANCE</div>
                            <div className="pvtbi-desc2">{parseFloat(this.get('tdl')).toFixed(1)}<span>km</span></div>
                        </div>
                    </div>
                </div>
                <div className="pv-block pv-triBlock">
                    <div className="pv-body">
                        <div className="pvtb-name">HIGH GEAR</div>
                        <div className="pvtb-item">
                            <div className="pvtbi-desc1">MACHINE MOVING</div>
                            <div className="pvtbi-desc2">{this.get('whm')}<span>hrs</span></div>
                        </div>
                        <div className="pvtb-item">
                            <div className="pvtbi-desc1">MACHINE IDLE</div>
                            <div className="pvtbi-desc2">{this.get('whi')}<span>hrs</span></div>
                        </div>
                        <div className="pvtb-item">
                            <div className="pvtbi-desc1">MACHINE DISTANCE</div>
                            <div className="pvtbi-desc2">{this.get('tdh')}<span>km</span></div>
                        </div>
                    </div>
                </div>
                <div className="pv-block pv-bigChartBlock">
                    <div className="pv-body">
                        <InPieChart ref="graph4" config={this.getPieConfig(4)}/>
                    </div>
                </div>
            </div>
        )
    }

}

export default PaverView;